import React from "react";
import styles from "./modal.scss";
import close from "../../../../assets/images/close-icon.svg";

const hireModal = ({ onHide, modalClick }) => (
  <div className={styles.modalcontainer}>
    <img src={close} className={styles.closebutton} onClick={() => onHide()} />
    <div className={styles.modalcontent}>
      <div className={styles.header}>
        <h2 className={styles.title}>Are you sure?</h2>
      </div>
      <div className={styles.intro}>
        <p className={styles.centered}>
          Click Yes to hire this member to work on your project. <br />
          By selecting this member, you will automatically decline all other
          members. <br />
          This will kick off the SOW process, which you can not undo. <br />
          Click "Cancel" if you are not ready to hire this member.
        </p>
      </div>
      <div className={styles.divider}>
        <div className={styles.top} />
        <div className={styles.bottom} />
      </div>
      <div className={styles.intro}>
        <div>
          <button
            className={styles.acceptButton}
            onClick={() => {
              modalClick();
              onHide();
            }}
          >
            {" "}
            YES{" "}
          </button>
        </div>
        <div className={styles.buttonContainer}>
          <span className={styles.link} onClick={() => onHide()}>
            Cancel
          </span>
        </div>
      </div>
    </div>
  </div>
);

export default hireModal;



// WEBPACK FOOTER //
// ./src/routes/employer/memberProfile/components/hireModal.js